import React from 'react'
import { Typography } from '@mui/material'
import { Dialog, Button } from 'bs-unified-ui'

interface UnifiedErrorDialogProps {
  title: string
  content: string | React.ReactNode
  maxWidth?: number | string
  cancelText?: string
  okText?: string
  children?: Function | string | React.ReactNode
  open: boolean
  onOk?: any
  onClose?: any
  onCancel?: any
  closeOnClick?: boolean
  loading?: boolean
  disabled?: boolean
  type: 'warn' | 'confirm'
}

const UnifiedConfirmDialog = ({
  title = '',
  content = '',
  maxWidth = 336,
  cancelText = 'Cancel',
  okText,
  children,
  open,
  onOk = () => {},
  onClose,
  onCancel = () => {},
  closeOnClick = false,
  loading,
  disabled,
  type = 'confirm',
  ...props
}: UnifiedErrorDialogProps) => {
  const handleClose = () => {
    if (closeOnClick) {
      onCancel()
      onClose()
    } else {
      onCancel()
    }
  }

  const handleOk = () => {
    if (closeOnClick) {
      onOk()
      onClose()
    } else {
      onOk()
    }
  }

  return (
    <Dialog
      open={open}
      title={title}
      maxWidth={maxWidth}
      onClose={handleClose}
      renderFooter={
        <>
          {cancelText ? (
            <Button variant="text" onClick={handleClose}>
              {cancelText}
            </Button>
          ) : null}
          <Button
            loading={loading}
            disabled={disabled}
            variant="contained"
            color={type === 'warn' ? 'error' : 'primary'}
            onClick={handleOk}
          >
            {okText}
          </Button>
        </>
      }
    >
      {children ? (
        <>{children}</>
      ) : (
        <Typography variant="fs14">{content}</Typography>
      )}
    </Dialog>
  )
}

export default UnifiedConfirmDialog
